import { Component, OnInit } from '@angular/core';
import {BsModalRef, BsModalService} from "ngx-bootstrap/modal";
import { first } from 'rxjs/operators'
import { ModalUpdateLocationComponent } from './modal-update-location/modal-update-location.component';
import {AuthApiService} from "../../../shared/core-jpats/services/auth.service";
import {UserManagementService} from "../../../shared/core-jpats/services/user-management.service";
import {LookupModel} from "../../../../../shared/core/app/api/models/lookup-model";


@Component({
  selector: 'modal-change-location',
  templateUrl: './modal-change-location.component.html',
  styleUrls: ['./modal-change-location.component.scss']
})
export class ModalChangeLocation implements OnInit {
  showWelcome: boolean=true;
  userName: string;
  currentLocation: LookupModel ={};
  currentFcc: LookupModel={};
  currentOperation: LookupModel={};
  bsModalRefUpdateLocation: BsModalRef;
  constructor(public bsModalRef: BsModalRef,
    private modalService: BsModalService,
    private authApiService: AuthApiService,
    private userManagementService: UserManagementService) {
  }

  ngOnInit() {
    this.userName = this.authApiService.getUsername();
    this.userManagementService.getCurrentCachedUser().subscribe((user)=>{
      this.currentLocation = user.location === null || !user.location ?  {} : user.location ;
      this.currentFcc = user.fcc === null || !user.fcc ? {} : user.fcc;
      this.currentOperation = user.operation === null || !user.operation ? {} : user.operation;
      if(this.currentLocation === null || this.currentFcc === null  || this.currentOperation === null ){
        this.bsModalRef.hide();
        this.bsModalRefUpdateLocation = this.modalService.show(ModalUpdateLocationComponent, { ignoreBackdropClick: true });

        this.bsModalRefUpdateLocation.onHidden.pipe(first()).subscribe(() => {
          //If all modals are closed, return focus to location button
          if (document.body.className.indexOf('modal-open') == -1) {
            document.getElementById("jpatsChangeLocationBtn")?.focus();
          }
        });

        setTimeout(function () {
          console.log("timeout");
          //Find input field in next modal & focus it
          let nextField = document.getElementById("editLocationOperationField")?.querySelector('select');
          if (nextField && nextField instanceof HTMLElement) {
            nextField.focus();
          }
        }, 200)

      }
    });
  }
  onLogout(){
    this.authApiService.logout();
    return false;
  }
  onEditLocation() {
    this.bsModalRef.hide();
    this.userManagementService.get().subscribe((res)=>{
      this.bsModalRefUpdateLocation = this.modalService.show(ModalUpdateLocationComponent, { ignoreBackdropClick: true });

      this.bsModalRefUpdateLocation.onHidden.pipe(first()).subscribe(() => {
        //If all modals are closed, return focus to location button
        if (document.body.className.indexOf('modal-open') == -1) {
          document.getElementById("jpatsChangeLocationBtn")?.focus();
        }
      });

      setTimeout(function () {
        //Find input field in next modal & focus it
        let nextField = document.getElementById("editLocationOperationField")?.querySelector('select');
        if (nextField && nextField instanceof HTMLElement) {
          nextField.focus();
        }
      }, 200)
    });
  }

  onContinue() {
    this.bsModalRef.hide();
  }

}
